import React, { FC, useEffect, useState } from 'react';
import MobileMenuNavButton from '../atoms/menu-nav-button';
import { ArrowLeftIcon } from '@heroicons/react/24/solid';
import { useFormat } from '../../hooks/useFormat';
import Typography from '@/components/atoms/typography';
import useTranslation from '@/providers/I18n/hooks/useTranslation';
import Select from '@/components/atoms/select';
import { Option } from '@/components/atoms/select/types';
import { useParams } from 'next/navigation';
import Modal from '@/components/organisms/modal';
import Button from '@/components/atoms/button';
import useAccount from '@/lib/hooks/useAccount';

export interface Props {
  links: any[];
  hideHeaderMenu: () => void;
  onArrowClick: () => void;
  categoriesNavigator?: any[]; //This is a navigator where you push a subcategory to show it's contents
  insertCategory: (category: any) => void;
  onLogoutClick: () => void;
  selectedBusinessUnit: string;
  businessUnits: Option[];
  onBusinessUnitChange?: (businessUnit: string) => void;
  isAdmin?: boolean
}




const MobileMenu: FC<Props> = ({
  links,
  categoriesNavigator,
  insertCategory,
  hideHeaderMenu,
  onArrowClick,
  onLogoutClick,
  selectedBusinessUnit,
  businessUnits,
  onBusinessUnitChange,
  isAdmin
}) => {
  // const isRegistrationPage = useIsCurrentPage(['/au/company-registration/', '/nz/company-registration/','/au/collection-statement/','/nz/collection-statement/']);
  const { account } = useAccount();
  const { formatMessage } = useFormat({ name: 'common' });
  const handleLogoutClick = () => {
    onLogoutClick();
    localStorage.removeItem('customerAccessToken');
  };
  const { translate } = useTranslation();
  const { locale } = useParams();

  const adminData = {
    label: 'My Account',
    mega_menu: {
      submenu_links: [
        {
          title: '',
          _metadata: {
            uid: 'cs82e9693e4dda59f1',
          },
          mega_menu: [
            // {
            //   mega_menu_content: "",
            //   mega_menu_url: {
            //     title: translate('common.dashboard'),
            //     href: `/${locale}/dashboard`
            //   },
            //   open_in_new_tab: false,
            // },
            // {
            //   mega_menu_content: "",
            //   mega_menu_url: {
            //     title: translate('common.category.sanit'),
            //     href: `/${locale}/order-tracking`
            //   },
            //   open_in_new_tab: false,
            // },
            // {
            //   mega_menu_content: "",
            //   mega_menu_url: {
            //     title: translate('common.category.shower'),
            //     href: `/${locale}/manage-orders`
            //   },
            //   open_in_new_tab: false,
            // },
            // {
            //   mega_menu_content: "",
            //   mega_menu_url: {
            //     title: translate('common.category.bath'),
            //     href: `/${locale}/delivery-estimator`
            //   },
            //   open_in_new_tab: false,
            // },
            // {
            //   mega_menu_content: "",
            //   mega_menu_url: {
            //     title: translate('common.category.basin'),
            //     href: `/${locale}/product-price-list`
            //   },
            //   open_in_new_tab: false,
            // },
            {
              mega_menu_content: "",
              mega_menu_url: {
                title: 'Profile Settings',
                href: `/profile-settings`
              },
              open_in_new_tab: false,
            },
            // {
            //   mega_menu_content: "",
            //   mega_menu_url: {
            //     title: translate('common.my.queries'),
            //     href: `/${locale}/my-queries`
            //   },
            //   open_in_new_tab: false,
            // },
            // {
            //   mega_menu_content: "",
            //   mega_menu_url: {
            //     title: translate('common.claim.and.returns'),
            //     href: `/${locale}/claim-and-returns`
            //   },
            //   open_in_new_tab: false,
            // },
            {
              mega_menu_content: "",
              mega_menu_url: {
                title: translate('common.team.management'),
                href: `/${locale}/team-management`
              },
              open_in_new_tab: false,
            },
            // {
            //   mega_menu_content: "",
            //   mega_menu_url: {
            //     title: translate('common.claim.and.returns'),
            //     href: `/${locale}/claim-and-returns`
            //   },
            //   open_in_new_tab: false,
            // },
          ],
        },
      ],
    },
  };

  const data = {
    label: 'My Account',
    mega_menu: {
      submenu_links: [
        {
          title: '',
          _metadata: {
            uid: 'cs82e9693e4dda59f1',
          },
          mega_menu: [
            // {
            //   mega_menu_content: "",
            //   mega_menu_url: {
            //     title: translate('common.dashboard'),
            //     href: `/${locale}/dashboard`
            //   },
            //   open_in_new_tab: false,
            // },
            // {
            //   mega_menu_content: "",
            //   mega_menu_url: {
            //     title: translate('common.category.sanit'),
            //     href: `/${locale}/order-tracking`
            //   },
            //   open_in_new_tab: false,
            // },
            // {
            //   mega_menu_content: "",
            //   mega_menu_url: {
            //     title: translate('common.category.shower'),
            //     href: `/${locale}/manage-orders`
            //   },
            //   open_in_new_tab: false,
            // },
            {
              mega_menu_content: "",
              mega_menu_url: {
                title: 'Profile Settings',
                href: `/profile-settings`
              },
              open_in_new_tab: false,
            },
            // {
            //   mega_menu_content: "",
            //   mega_menu_url: {
            //     title: translate('common.my.queries'),
            //     href: `/${locale}/my-queries`
            //   },
            //   open_in_new_tab: false,
            // },
            // {
            //   mega_menu_content: "",
            //   mega_menu_url: {
            //     title: translate('common.claim.and.returns'),
            //     href: `/${locale}/claim-and-returns`
            //   },
            //   open_in_new_tab: false,
            // },
            // {
            //   mega_menu_content: "",
            //   mega_menu_url: {
            //     title: translate('common.category.bath'),
            //     href: `/${locale}/delivery-estimator`
            //   },
            //   open_in_new_tab: false,
            // },
            // {
            //   mega_menu_content: "",
            //   mega_menu_url: {
            //     title: translate('common.category.basin'),
            //     href: `/${locale}/product-price-list`
            //   },
            //   open_in_new_tab: false,
            // },
          ],
        },
      ],
    },
  };
  // const handleChange = (selectedOption: string) => {
  //   onBusinessUnitChange?.(selectedOption);

  //   hideHeaderMenu?.();
  // };
  const [newBusinessUnit, setNewBusinessUnit] = useState<string | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const closeModal = () => {
    setIsModalOpen(false);
  };
  useEffect(() => {
    const body = document.body;
    if (isModalOpen) {
      body.style.overflow = 'hidden';
      body.classList.add('modal-open');
    } else {
      body.style.overflow = '';
      body.classList.remove('modal-open');
    }
    return () => {
      body.style.overflow = '';
      body.classList.remove('modal-open');
    };
  }, [isModalOpen]);

  const handleBusinessUnitChange = () => {
    if (newBusinessUnit && onBusinessUnitChange) {
      onBusinessUnitChange(newBusinessUnit);
      closeModal();
    }
  };

  const handleSelectChange = (value: string) => {
    if (value !== selectedBusinessUnit) {
      setNewBusinessUnit(value);
      if (businessUnits.length > 1) {
        setIsModalOpen(true);
      }
    }
  };

  return (
    <>
      <div className="h-full overflow-y-auto bg-[#F3EDE9] pb-48">
        <div className="menu-dropdown">
          {/*  */}
        </div>
        {categoriesNavigator && categoriesNavigator.length <= 0 ? (
          <>
            {links?.map((link, index) => (
              <MobileMenuNavButton
                key={index}
                categoriesNavigator={categoriesNavigator}
                link={link}
                onClick={() => insertCategory(link)}
                hideHeaderMenu={hideHeaderMenu}
              />
            ))}
            <MobileMenuNavButton
              categoriesNavigator={categoriesNavigator}
              link={isAdmin ? adminData : data}
              onClick={() => insertCategory(isAdmin ? adminData : data)}
              hideHeaderMenu={hideHeaderMenu}
            />
            <div
              onClick={handleLogoutClick}
              className={'flex cursor-pointer justify-between border-b-2 border-white px-[48px] py-[14px]'}
            >
              <Typography className="text-20 font-semibold text-[#090909]">{'Sign Out'}</Typography>
            </div>
          </>
        ) : (
          <>
            {categoriesNavigator && (
              <div
                onClick={onArrowClick}
                className="flex cursor-pointer items-center gap-[8px] bg-[#2B2C39] px-[16px] py-[14px]"
              >
                <ArrowLeftIcon className="w-[24px] text-white" />
                <Typography className="text-20  font-semibold text-white">
                  {categoriesNavigator[categoriesNavigator.length - 1]?.label}
                </Typography>
              </div>
            )}

            {categoriesNavigator &&
              categoriesNavigator[categoriesNavigator.length - 1]?.mega_menu?.submenu_links?.map(
                (nav: any, index: number) => (
                  <MobileMenuNavButton
                    key={index}
                    categoriesNavigator={categoriesNavigator}
                    link={nav}
                    onClick={() => insertCategory(nav)}
                    hideHeaderMenu={hideHeaderMenu}
                  />
                ),
              )}
          </>
        )}
      </div>
      <Modal
        className="flex flex-col items-center justify-center !p-10"
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        preventScroll={false}
        closeButton={true}
        size="sm"
        variant="default"
        centered={true}
      >
        <div className="div">
          <Typography className="text-center text-16 !font-medium text-black">
            {translate('common.switch.company')}
          </Typography >
          <Typography className=" mt-4 text-center text-16 !font-medium text-black">{translate('common.switch.details')}</Typography>
          <Typography className=" mt-4 text-center text-16 !font-medium text-black">{translate('common.switch.buconfirm')}</Typography>
        </div>
        <div className="flex gap-4">
          <Button
            size="custom"
            variant="secondary"
            type="submit"
            className="mt-5 bg-[#2B2C39] !py-3 px-6 text-white"
            onClick={handleBusinessUnitChange}
          >
            {translate('common.yes')}
          </Button>
          <Button
            size="custom"
            variant="secondary"
            type="submit"
            className="mt-5 bg-[#2B2C39] !py-3 px-6 text-white"
            onClick={() => {
              setIsModalOpen(false);
            }}
          >
            {translate('common.no')}
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default MobileMenu;